// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__KnIqs","label-wrapper":"Input_label-wrapper__l901d"};